import { render, staticRenderFns } from "./DrugExternalCosts.vue?vue&type=template&id=ceea64c8&scoped=true&lang=pug"
import script from "./DrugExternalCosts.vue?vue&type=script&lang=js"
export * from "./DrugExternalCosts.vue?vue&type=script&lang=js"
import style0 from "./DrugExternalCosts.vue?vue&type=style&index=0&id=ceea64c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceea64c8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Spinner: require('/home/docker/code/frontend/components/Spinner.vue').default,Summary: require('/home/docker/code/frontend/components/Summary.vue').default})
